import React, { useContext } from "react"
import { CampProps } from "../../interfaces"
import IOrder from "../../interfaces/IOrder"
import { formatMoneyFromCents } from "~/utils/formatMoney"
import { NewReservationContext } from "~/contexts/admin/NewReservationContext"
import { AdminContext } from "~/contexts/AdminContext"
import { RESERVATION_KINDS } from "~/constants"
import classNames from "~/utils/classNames"

const LineItems = ({ order, camp }: { order: IOrder | null; camp: CampProps }) => {
  const { newReservation, selectedSitesForGroup } = useContext(NewReservationContext)
  const { sites } = useContext(AdminContext)

  return (
    <div className={classNames("overflow-y-auto scrollbar-thin", "flex-grow-1 max-h-[530px]")}>
      {order?.line_items?.map((lineItem) => (
        <div className="mb-2 flex justify-between items-center w-full border border-gray-300 rounded-md py-2 px-3">
          <div className="flex flex-col text-mdbase">
            <div className="font-semibold">
              <span>{lineItem?.label}</span>
              {lineItem?.kind === "basic" && !lineItem?.add_on_id && (
                <>
                  <span className="ml-1">x {lineItem?.occurrences} nights</span>
                </>
              )}
              {(lineItem?.kind !== "basic" || lineItem?.add_on_id) && (
                <span className="ml-1">x {lineItem.quantity}</span>
              )}
            </div>
            {lineItem?.kind === "basic" && lineItem.label === "Reservation" && (
              <div className="flex items-center text-sm">
                <div
                  className="max-w-[190px] truncate pr-2"
                  title={
                    newReservation.kind === RESERVATION_KINDS.GROUP
                      ? selectedSitesForGroup.map((site) => site.name).join(", ")
                      : undefined
                  }
                >
                  {newReservation.kind === RESERVATION_KINDS.GROUP
                    ? selectedSitesForGroup.map((site) => site.name).join(", ")
                    : sites?.find((site) => site.id === newReservation.site_id)?.name}
                </div>
                <div>
                  {newReservation.start_date?.format("MMM D")} - {newReservation.end_date?.format("MMM D")}
                </div>
              </div>
            )}
          </div>
          <div className="text-sm font-semibold">
            <div>{formatMoneyFromCents(lineItem?.total_amount_in_cents, camp?.currency)}</div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default LineItems
